module.exports = __webpack_public_path__ + "img/product_28.c89fc82.svg";